export const text = {
  Keys: "Keys",
  AddKey: "Add Key",
  KeyFolder: "Key Folder",
  KeyFolderaddedsuccessfully: "Key Folder added successfully!",
  KeyFolderupdatedsuccessfully: "Key Folder updated successfully!",
  KeyFolderDeletedsuccessfully: "Key Folder Deleted successfully!",
};
